export default __webpack_public_path__ + "static/media/scam-pepe.86ce7118.png";